<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Selecciona Documento</h4>
    <br>

    <button type="button" class="close" aria-label="Close" (click)="cerrar()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <span>haz doble click y selecciona un documento</span>
    <br>
    <ngx-table #table [configuration]="configuration" [data]="dataTable" [columns]="columns"
        (event)="eventEmitted($event)"></ngx-table>
    
        <ng-template #frmEstado let-row let-rowIndex="rowIndex">
            <span class="badge badge-primary" *ngIf="row.DocStatus=='O'">Abierta</span>
            <span class="badge badge-danger" *ngIf="row.DocStatus=='C'">Cerrada</span>
        </ng-template>
        <ng-template #frmU_IND_EstadosNV let-row let-rowIndex="rowIndex">
            <span class="badge bg-info" *ngIf="row.U_IND_EstadosNV=='1'">Recibido</span>
            <span class="badge bg-warning" *ngIf="row.U_IND_EstadosNV=='2'">En preparación</span>
            <span class="badge bg-success" *ngIf="row.U_IND_EstadosNV=='3'">Preparado</span>
            
        </ng-template>
        <ng-template #frmVendedor let-row let-rowIndex="rowIndex">
            {{this.vendedorCodigoATexto(row.SlpCode)}}
        </ng-template>
        <ng-template #frmFechaDocumento let-row let-rowIndex="rowIndex">
            {{row.DocDate | date: 'dd/MM/yyyy'}}
        </ng-template>

        <ng-template #frmDocTotal let-row let-rowIndex="rowIndex">
            {{row.DocTotal | iNDCLP}}
        </ng-template>

        <ng-template #frmAccion let-row let-rowIndex="rowIndex">
            
            <ng-container *ngFor="let item of tablaObjetos">

                <ng-container *ngIf="row.ObjType == item.ObjType">
                    {{item.DESCRIPCION}}
                </ng-container>
                
            
            </ng-container>

        </ng-template>

</div>